import http from '../../../http/base';
import { API_PATHS } from '../../../http/configs';

export function checkPaymentsExist(programTypeID, programPaymentTypeID, periodID, partnerID, paymentTypeID) {
    return http.get(API_PATHS.checkPartnerPaymentsExist, { params: { programTypeID, programPaymentTypeID, periodID, partnerID, paymentTypeID } });
}

export function generate(generateParams) {
    return http.post(API_PATHS.generatePartnerPayments, generateParams);
};